export enum CondicionIVA {
    ResponsableInscriptoSinIVA,
    NoCategorizado,
    IvaExentoExportacion,
    IvaNoAlcanzado,
    Exento,
    ConsumidorFinal,
    Monotributo,
    ResponsableInscripto,
    Indefinido
}